import JobDetail1Container from "../../../components/job/detail/JobDetail1";

const JobDetail1 = () => {
  return <JobDetail1Container />;
};

export default JobDetail1;
